var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnityHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 144,
    viewBox: "0 0 203 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.5 125.315L144.967 100.15L128.387 90.4884L111.358 100.375C110.686 100.824 110.014 100.375 110.014 99.476V76.1084C110.014 75.4343 110.462 74.7603 110.91 74.5356L131.075 62.8518C131.748 62.4024 132.42 62.8518 132.42 63.7506V83.5231L149 93.1847V42.6299L101.5 70.2665V125.315Z",
    fill: "#D8D8D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.757 18V36.9925L122.785 46.7096C123.458 47.1513 123.458 48.0347 122.785 48.2555L102.62 59.7394C101.948 60.181 101.276 59.9602 100.828 59.7394L80.6627 48.2555C79.9906 48.0347 79.9906 46.9305 80.6627 46.7096L97.691 36.9925V18L54 42.7344L101.5 69.8981L149 42.7344L105.757 18Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6878 100.375L74.7394 90.4884L58.2371 100.15L101.5 125.315V70.2665L54 42.6299V92.96V92.7353V92.96L70.5023 83.2984V63.5259C70.5023 62.8518 71.3944 62.4024 71.8404 62.6271L91.9108 74.3109C92.5798 74.7603 92.8028 75.2096 92.8028 75.8837V99.2513C93.0258 100.15 92.3568 100.824 91.6878 100.375V100.375Z",
    fill: "#F9F9F9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnityHover);
export default __webpack_public_path__ + "static/media/unityHover.de3d8a6c30f006b194986aa5631d76bd.svg";
export { ForwardRef as ReactComponent };